import { z } from 'zod';

export const commonSchema = z.object({
    sendEmail: z.boolean().optional(),
    userId: z.string().optional(),
});
